"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorEnabledEventArgs = void 0;
const EventType_1 = require("../EventType");
class ActorEnabledEventArgs {
    constructor() {
        this.__type = EventType_1.EventType.ActorEnabled;
        this.__typeName = "ActorEnabled";
    }
}
exports.ActorEnabledEventArgs = ActorEnabledEventArgs;
